<template>
    <div class="content-wrapper">
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>
        <breadcrumb :page="$t('form.student.statusImport')"></breadcrumb>
        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{ alertMessage }}</b-alert>
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{ $t('form.student.statusImport') }}</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="border border-dark p-2 mb-5">
                                    <a href="/templates/CSV-Sample-StatusImport.csv" class="mb-3 d-block" download>{{ $t('form.import.download') }}</a>
                                    <div class="font-weight-bold">{{ $t('form.import.requirement') }}</div>
                                    <ul>
                                        <li>{{ $t('form.student.statusImportColumns') }}</li>
                                        <li>{{ $t('form.student.statusImportDateRule') }}</li>
                                        <li>{{ $t('form.import.requirement2', {format: dateFormat}) }}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <b-form-checkbox class="mb-4" v-model="header">
                                    {{ $t('form.import.csvHeader') }} <br>
                                    <span class="font-weight-normal">{{ $t('form.import.csvHeaderText') }}</span>
                                </b-form-checkbox>
                                <b-form-checkbox class="mb-4" v-model="delimiter">
                                    {{ $t('form.import.csvDelimiter') }} <br>
                                    <span class="font-weight-normal">{{ $t('form.import.csvDelimiterText') }}</span>
                                </b-form-checkbox>
                                <b-form-checkbox class="mb-4" v-model="qualifier">
                                    {{ $t('form.import.csvQualifier') }} <br>
                                    <span class="font-weight-normal">{{ $t('form.import.csvQualifierText') }}</span>
                                </b-form-checkbox>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label class="control-label">{{ $t('form.student.uploadFile') }}</label>
                                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                        @vdropzone-sending="importingData"
                                        @vdropzone-complete="fileSubmitted"
                                        @vdropzone-processing="isLoading = true">
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";

export default {
    props: ['permissions', 'dateFormat'],
    components: { vueDropzone: vue2Dropzone },
    data() {
        return {
            alert: false,
            alertClass: '',
            alertMessage: '',
            isLoading: false,
            fullPage: true,
            dropzoneOptions: {
                url: "/api/status/import",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content,
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                thumbnailWidth: 150,
                thumbnailHeight: 150
            },
            header: true,
            delimiter: true,
            qualifier: false
        };
    },
    mounted() {
        if (!this.permissions.createImportGraduations) {
            this.$router.push('/');
        }
        let savedRecordStatus = window.localStorage.getItem('dataSaved');
        if (savedRecordStatus) {
            this.showAlert(savedRecordStatus);
            window.localStorage.removeItem('dataSaved');
        }
    },
    methods: {
        importingData(file, xhr, formData) {
            formData.append('heading_row', this.header ? 1 : 0);
            formData.append('delimiter', this.delimiter ? 1 : 0);
            formData.append('qualifier', this.qualifier ? 1 : 0);
        },
        fileSubmitted(response) {
            this.isLoading = false;
            let data = JSON.parse(response.xhr.response);
            if (response.status == 'success') {
                this.showAlert(data.message);
                window.localStorage.setItem('statuses', JSON.stringify(data.data));
                window.localStorage.setItem('statusPath', data.data.path);
                this.$router.push({ name: 'StatusImportPreview' });
            } else if (response.status == 'error') {
                this.showAlert(data.message, 'danger');
            }
        },
        showAlert(msg, cls = 'success') {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        }
    }
};
</script>